/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserMiniReference,
    ElementsUserMiniReferenceFromJSON,
    ElementsUserMiniReferenceFromJSONTyped,
    ElementsUserMiniReferenceToJSON,
    MediaRootMiniReference,
    MediaRootMiniReferenceFromJSON,
    MediaRootMiniReferenceFromJSONTyped,
    MediaRootMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SavedSearch
 */
export interface SavedSearch {
    /**
     * 
     * @type {number}
     * @memberof SavedSearch
     */
    id: number;
    /**
     * 
     * @type {ElementsUserMiniReference}
     * @memberof SavedSearch
     */
    user: ElementsUserMiniReference;
    /**
     * 
     * @type {MediaRootMiniReference}
     * @memberof SavedSearch
     */
    root?: MediaRootMiniReference;
    /**
     * 
     * @type {Array<string>}
     * @memberof SavedSearch
     */
    query: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SavedSearch
     */
    readonly url: string;
    /**
     * 
     * @type {string}
     * @memberof SavedSearch
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof SavedSearch
     */
    shared?: boolean;
}

export function SavedSearchFromJSON(json: any): SavedSearch {
    return SavedSearchFromJSONTyped(json, false);
}

export function SavedSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavedSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user': ElementsUserMiniReferenceFromJSON(json['user']),
        'root': !exists(json, 'root') ? undefined : MediaRootMiniReferenceFromJSON(json['root']),
        'query': json['query'],
        'url': json['url'],
        'name': json['name'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
    };
}

export function SavedSearchToJSON(value?: SavedSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user': ElementsUserMiniReferenceToJSON(value.user),
        'root': MediaRootMiniReferenceToJSON(value.root),
        'query': value.query,
        'name': value.name,
        'shared': value.shared,
    };
}


